// enviroment: cordova

import System from './system';

let messaging = null;

export default class PushNotification {
    static setup () {
        // Initialize Firebase
        if (!System.platform.cordova) {
            var config = {
                apiKey: 'AIzaSyCEEhmyGcpAkskQPmJ9t2Zxd_-zu-rL8P8',
                authDomain: 'ufjf-game-mobile.firebaseapp.com',
                databaseURL: 'https://ufjf-game-mobile.firebaseio.com',
                projectId: 'ufjf-game-mobile',
                storageBucket: 'ufjf-game-mobile.appspot.com',
                messagingSenderId: '837983563419'
            };
            firebase.initializeApp(config);
            messaging = firebase.messaging();
        }
    }

    static getPermission (onSuccess, onFail) {
        if (!System.platform.cordova) {
            messaging.requestPermission()
                .then(onSuccess)
                .catch(onFail);
        } else {
            onSuccess();
        }
    }

    static getToken (onSuccess, onFail) {
        if (System.platform.cordova) {
            console.log('GET_TOKEN');
            window.FirebasePlugin.getToken(onSuccess, onFail);
        } else {
            messaging.getToken()
                .then(onSuccess)
                .catch(onFail);
        }
    }

    static getMessage () {
        if (!System.platform.cordova) {
            messaging.onMessage(function (payload) {
                console.log('onMessage: ', payload);
            });
        }
    }

    static onTokenRefresh (onSuccess, onFail) {
        if (System.platform.cordova) {
            window.FirebasePlugin.onTokenRefresh(onSuccess, onFail);
        } else {
            messaging.onTokenRefresh(onSuccess, onFail);
        }
    }

    static onNotificationOpen (onSuccess, onFail) {
        if (System.platform.cordova) {
            window.FirebasePlugin.onNotificationOpen(onSuccess, onFail);
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/pushNotification.js